const scope = 'OneHomePage/DocumentsPage/';
export const SET_LOADING_FLAG = `${scope}SET_LOADING_FLAG`;
export const ADD_DOCUMENTS = `${scope}ADD_DOCUMENTS`;
export const ADD_FOLDER = `${scope}ADD_FOLDER`;
export const UPDATE_DOCUMENT = `${scope}UPDATE_DOCUMENT`;
export const UPLOAD_DOCUMENT = `${scope}UPLOAD_DOCUMENT`;
export const UPLOAD_DOCUMENT_SUCCESS = `${scope}UPLOAD_DOCUMENT_SUCCESS`;
export const UPLOAD_DOCUMENT_FAILED = `${scope}UPLOAD_DOCUMENT_FAILED`;
